'use client';
import { ReactNode } from 'react';
import { styled } from 'styled-components';

export type ContentTextType =
  | 'article-l-b'
  | 'article-l'
  | 'article-m'
  | 'label-xl'
  | 'label-l'
  | 'label-m'
  | 'label-s'
  | 'menu-m'
  | 'note-l'
  | 'note-m'
  | 'button'
  | 'button-s'
  | 'price-l'
  | 'price';

type Props = {
  children: ReactNode;
  type?: ContentTextType;
  color?: string;
  className?: string;
  underbar?: boolean;
  $whitespace?:
    | 'normal'
    | 'nowrap'
    | 'pre'
    | 'pre-wrap'
    | 'pre-line'
    | 'break-spaces';
};
const ContentText: React.FC<Props> = (props) => {
  return (
    <Container
      {...props}
      className={props.className}
      type={props.type ?? 'article-l'}
    >
      {props.children}
    </Container>
  );
};

const Container = styled.span<Props>`
  ${(props) => {
    if (props.color) {
      return `color:${props.color};`;
    }
  }}
  ${(props) => {
    if (props.underbar) {
      return `border-bottom: 2px solid;`;
    }
  }}
  ${(props) => {
    if (props.$whitespace) {
      return `white-space: ${props.$whitespace};`;
    }
  }}
  /* font-family: 'Yu Mincho'; */
  width: fit-content;
  ${({ type }) => {
    switch (type) {
      case 'article-l-b':
        return `
            font-size: 1rem;
            font-weight: 600;
            line-height: 1.75;
            letter-spacing: 0.04em;
        `;
      case 'article-l':
        return `
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.75;
            letter-spacing: 0.04em;
        `;
      case 'article-m':
        return `
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.75;
            letter-spacing: 0.04em;
            text-align: left;
        `;
      case 'label-xl':
        return `
            font-size: 1rem;
            font-weight: 600;
            line-height: 1.5;
            letter-spacing: 0.04em;
            text-align: left;
      `;
      case 'label-l':
        return `
            font-size: 0.875rem;
            font-weight: 600;
            line-height: 1.5;
            letter-spacing: 0.04em;
            text-align: left;
      `;
      case 'label-m':
        return `
            font-size: 0.75rem;
            font-weight: 600;
            line-height: 1.5;
            letter-spacing: 0.0125em;
            text-align: left;
        `;
      case 'label-s':
        return `
              font-size: 0.625rem;
              font-weight: 600;
              line-height: 1.2;
              letter-spacing: 0.0125em;
              text-align: left;
          `;
      case 'menu-m':
        return `
          font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.2;
            letter-spacing: 0.015em;
            text-align: left;
        `;
      case 'note-l':
        return `
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.75;
            letter-spacing: 0.0125em;
            text-align: left;
        `;
      case 'note-m':
        return `
            font-size: 0.75rem;
            font-weight: 400;
            line-height: 1.75;
            letter-spacing: 0.015em;
            text-align: left;
        `;
      case 'label-xl':
      case 'button':
        return `
            font-size: 1rem;
            font-weight: 600;
            line-height: 1.5;
            letter-spacing: 0.04em;
            text-align: left;
          `;
      case 'button-s':
        return `
            font-size: 0.875rem;
            font-weight: 600;
            line-height: 1.5;
            letter-spacing: 0.04em;
            text-align: left;
          `;
      case 'price-l':
        return `
            font-size: 2.25rem;
            font-weight: 600;
            line-height: 1.25;
            letter-spacing: 0em;
            text-align: left;
            `;
      case 'price':
        return `
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.25;
        letter-spacing: 0em;
        text-align: left;
        `;
    }
  }}
`;
export default ContentText;
